var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.$style.root }, [
    _c(
      "i",
      {
        class: [_vm.$style.note, "note", "material-icons"],
        style: { color: _vm.note.color },
      },
      [_vm._v("text_snippet")]
    ),
    _c("div", { class: _vm.$style.text, style: `--color: ${_vm.note.color}` }, [
      _c("p", { class: _vm.$style.title }, [_vm._v(_vm._s(_vm.note.title))]),
      _c("div", {
        domProps: { innerHTML: _vm._s(_vm.note.note.replace(/\n/g, "<br>")) },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }